<template>
  <div class="series-list">
    <div class="table-search">
      <el-form ref="form" :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="品牌名称：" prop="seriesName">
          <el-input v-model="form.seriesName" placeholder="请输入品牌名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="success"
            v-if="isShowBatch"
            @click="handleConfig"
          >批量设置</el-button>
          <el-button
            type="success"
            v-if="!isShowBatch"
            @click="handleBatchShelves(1)"
          >批量上架</el-button>
          <el-button
            type="success"
            v-if="!isShowBatch"
            @click="handleBatchShelves(0)"
          >批量下架</el-button>
          <el-button type="primary" @click="handleInputChange">查询</el-button>
          <el-button type="primary" @click="handleAdd">添加</el-button>
          <el-button type="primary" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @select="handleSingleChange"
        @select-all="handleAllchange"
      >

        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column prop="seriesSort" label="排序" align="center"></el-table-column>
        <el-table-column prop="seriesName" label="系列名称" align="center"></el-table-column>
        <el-table-column prop="seriesEnglishName" label="系列英文名" align="center"></el-table-column>
        <el-table-column prop="brandName" label="所属品牌" align="center"></el-table-column>
        <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.seriesState">上架</span>
            <span v-else>下架</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="150px">
          <template slot-scope="scope">
            <span
              class="upShelves"
              v-if="!scope.row.seriesState"
              @click="handleShelves(scope.row.id,1)"
            >上架</span>
            <span
              class="downShelves"
              v-else
              @click="handleShelves(scope.row.id,0)"
            >下架</span>
            <span class="view" @click="handlePreview(scope.row)">预览</span>
            <el-popover
              popper-class="wechatCode"
              placement="top"
              width="60"
              trigger="click">
              <img :src="scope.row.seriesQrCode" alt class="wechatImg" />
              <span class="wechat" slot="reference">小程序码</span>
            </el-popover>
            <span class="del" @click="handleDel(scope.row.id)">删除</span>
            <span class="editor" @click="handleEditor(scope.row.id)">编辑</span>
            <span class="path" @click="openDialog(scope.row.seriesPath)">页面路径</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <copyDialog :visible="visible" :configPath="seriesPath" @close="visible = false"/>
    <Preview
      :visible="previewVisible"
      :selectId="currentCellId"
      @close="handleClosePreview"
    />
  </div>
</template>
<script>
import { getSeriesList, updateSeriesUpAndDown, deleteSeries } from '@/api/series';
import Preview from '@/components/h5/seriesPage.vue';
import copyDialog from '@/components/copyDialog';
import Pagination from '@/components/Pagination';
import batch from '@/mixins/batch';
import preview from '@/mixins/mobile';

export default {
  mixins: [batch, preview],
  data() {
    return {
      visible: false,
      seriesPath: '',
      form: {
        seriesName: '',
      },
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
    };
  },
  components: {
    copyDialog,
    Pagination,
    Preview,
  },
  mounted() {
    this.getSeriesList();
  },
  methods: {
    getSeriesList() {
      this.loading = true;
      return getSeriesList({
        seriesName: this.form.seriesName,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
          return false;
        }
        this.$message.error(res.message);
        return false;
      });
    },
    updateSeriesUpAndDown(ids, seriesState) {
      updateSeriesUpAndDown(ids, seriesState).then((res) => {
        if (res.success) {
          this.getSeriesList();
          this.$message.success('操作成功');
        } else {
          this.$message.error('操作失败');
        }
      });
    },
    // 输入查询
    handleInputChange() {
      this.currentPage = 1;
      this.getSeriesList();
    },
    // 单个上下架
    handleShelves(id, seriesState) {
      this.updateSeriesUpAndDown(id, seriesState);
    },
    // 批量上下架
    handleBatchShelves(seriesState) {
      const tempArr = this.getDealArr();
      if (tempArr.length > 0) {
        this.updateSeriesUpAndDown(tempArr, seriesState);
        this.clearSelection();
      } else {
        this.$message.warning('请选择需要至少一条数据后操作！');
      }
    },
    // 删除
    handleDel(id) {
      deleteSeries(id).then((res) => {
        if (res.success) {
          this.$message.success('删除成功');
          this.getSeriesList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 页面路径
    openDialog(path) {
      this.seriesPath = path;
      this.visible = true;
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getSeriesList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getSeriesList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getSeriesList().then((res) => {
        if (res) {
          this.findSelectionItem(res);
        }
      });
    },
    handleEditor(id) {
      this.$router.push({
        name: 'SeriesEditor',
        query: {
          id,
        },
      });
    },
    // 添加会员卡
    handleAdd() {
      this.$router.push({ name: 'SeriesAdd' });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.demo-form-inline
  flex-row()
  justify-content space-between
.view, .wechat, .del, .editor, .path, .upShelves, .downShelves
  color #1890ff
  cursor pointer
.view, .wechat, .del, .editor, .upShelves, .downShelves
  margin-right 20px
.memberImg
  width 150px
  height 100px
.wechatImg
  width 150px
  height 150px
</style>
<style lang="stylus">
.wechatCode
  background rgba(0, 0, 0, 0)
  min-width 150px
  padding 0
  border none
  margin 0
</style>
